import { useState, useEffect, useRef } from "react";
import { supabase } from "./supabase";

const C = {
  bg:"#f8f5f0", surface:"#ffffff", card:"#ffffff", border:"#e8e4df",
  borderGold:"rgba(201,168,76,0.25)", goldBg:"rgba(201,168,76,0.08)",
  gold:"#c9a84c", goldL:"#e8c96a", goldD:"#8a6f2e",
  green:"#2ecc87", greenL:"rgba(46,204,135,0.12)",
  red:"#e05555", redL:"rgba(224,85,85,0.12)",
  blue:"#4a9eff", blueL:"rgba(74,158,255,0.12)",
  purple:"#9b6ef3", purpleL:"rgba(155,110,243,0.12)",
  teal:"#2dd4bf", tealL:"rgba(45,212,191,0.12)",
  orange:"#f97316", orangeL:"rgba(249,115,22,0.12)",
  whatsapp:"#25d366", whatsappL:"rgba(37,211,102,0.12)",
  sms:"#4a9eff",
  text:"#1a1a2e", muted:"#6b7280", dim:"#9ca3af", light:"#f3f4f6",
};
const F="'Montserrat','Plus Jakarta Sans',sans-serif";
const S="'Playfair Display','Cormorant Garamond',Georgia,serif";

// ── TREATMENT TIMING ──────────────────────────────────────────────────────────
const TREAT_TIMING={
  "Botox":{days:90,label:"3 months",msg:"Your Botox is due for a refresh!"},
  "Lip Filler":{days:180,label:"6 months",msg:"Time for your lip filler touch-up!"},
  "Cheek Filler":{days:270,label:"9 months",msg:"Your cheek filler may need a refresh!"},
  "Juvederm":{days:240,label:"8 months",msg:"Your Juvederm is due for a refresh!"},
  "Sculptra":{days:180,label:"6 months",msg:"Your Sculptra touch-up is due!"},
  "Laser Hair Removal":{days:42,label:"6 weeks",msg:"Time for your next laser session!"},
  "IPL Photofacial":{days:42,label:"6 weeks",msg:"Your next IPL session is due!"},
  "CO2 Laser":{days:365,label:"12 months",msg:"Time for your annual CO2 touch-up!"},
  "RF Microneedling":{days:35,label:"5 weeks",msg:"Your RF Microneedling series continues!"},
  "HydraFacial":{days:28,label:"4 weeks",msg:"Ready for your monthly HydraFacial?"},
  "Chemical Peel":{days:28,label:"4 weeks",msg:"Time for your next chemical peel!"},
  "Dermaplaning":{days:28,label:"4 weeks",msg:"Your skin is ready for Dermaplaning again!"},
  "PRP Hair":{days:42,label:"6 weeks",msg:"Your PRP series continues!"},
  "GLP-1 Program":{days:30,label:"Monthly",msg:"Your monthly GLP-1 check-in is due!"},
  "IV Therapy":{days:30,label:"Monthly",msg:"Ready for your monthly IV therapy?"},
  "Ultherapy":{days:365,label:"12 months",msg:"Your annual Ultherapy is due!"},
  "Kybella":{days:60,label:"2 months",msg:"Your next Kybella session is ready!"},
};

// ── AI CONVERSATION DATA ──────────────────────────────────────────────────────
const INIT_CONVERSATIONS=[
  {
    id:1, client:"Rachel Summers", phone:"(310) 555-0142", channel:"sms",
    trigger:"Botox", lastTreat:"2024-01-22", daysAgo:92,
    status:"booked", outcome:"booked",
    apptBooked:{date:"2024-04-25",time:"10:00",treat:"Botox",prov:"Dr. Ashley Monroe"},
    messages:[
      {role:"ai",text:"Hi Rachel! 👋 It's Elyon — just a friendly reminder that it's been about 3 months since your last Botox with Dr. Monroe. Ready to book your refresh? I can check availability right now 💉",time:"10:02 AM",read:true},
      {role:"client",text:"Yes! I was just thinking about this 😊 When is Dr. Monroe available?",time:"10:15 AM",read:true},
      {role:"ai",text:"Great timing! Dr. Monroe has these openings this week:\n\n📅 Thu Apr 25 — 10:00 AM\n📅 Thu Apr 25 — 2:30 PM\n📅 Fri Apr 26 — 9:00 AM\n📅 Fri Apr 26 — 11:30 AM\n\nWhich works best for you?",time:"10:15 AM",read:true},
      {role:"client",text:"Thursday 10am works perfectly!",time:"10:18 AM",read:true},
      {role:"ai",text:"✅ Perfect! I've booked you:\n\n📅 Thursday, April 25\n⏰ 10:00 AM\n💉 Botox with Dr. Ashley Monroe\n📍 Beverly Hills Suite A\n\nYou'll receive a confirmation shortly. See you then! 💛\n\nReply CANCEL to cancel or CHANGE to reschedule.",time:"10:18 AM",read:true},
    ]
  },
  {
    id:2, client:"Dana Whitfield", phone:"(213) 555-0177", channel:"whatsapp",
    trigger:"Cheek Filler", lastTreat:"2023-07-10", daysAgo:198,
    status:"booked", outcome:"booked",
    apptBooked:{date:"2024-02-08",time:"11:00",treat:"Cheek Filler",prov:"Chloe Kim NP"},
    messages:[
      {role:"ai",text:"Hi Dana! 💛 It's your Elyon AI assistant. Your cheek filler from July is around 9 months old — you might be noticing it's fading slightly. Dr. Monroe and Chloe Kim are available this week. Want me to lock in a time?",time:"9:00 AM",read:true},
      {role:"client",text:"Yes please! What does Chloe have?",time:"9:22 AM",read:true},
      {role:"ai",text:"Chloe Kim NP has:\n\n📅 Thu Feb 8 — 11:00 AM ✨\n📅 Fri Feb 9 — 2:00 PM\n📅 Mon Feb 12 — 10:30 AM\n\nAs a Platinum member, you also get priority booking 👑",time:"9:23 AM",read:true},
      {role:"client",text:"Thu Feb 8 at 11",time:"9:25 AM",read:true},
      {role:"ai",text:"✅ Done! Booked:\n\n📅 Thursday, February 8\n⏰ 11:00 AM\n✨ Cheek Filler with Chloe Kim NP\n📍 Beverly Hills Suite B\n💳 Your Platinum member discount applied\n\nSee you then Dana! 💛",time:"9:25 AM",read:true},
    ]
  },
  {
    id:3, client:"Noah Bennett", phone:"(818) 555-0133", channel:"sms",
    trigger:"Botox", lastTreat:"2024-01-22", daysAgo:88,
    status:"objection", outcome:"pending",
    apptBooked:null,
    messages:[
      {role:"ai",text:"Hey Noah! It's Elyon — your Botox with Dr. Monroe was about 3 months ago. Ready to book your refresh? Natural results, just like last time 💉",time:"2:00 PM",read:true},
      {role:"client",text:"Hmm maybe next month, I'm a bit tight on budget right now",time:"2:45 PM",read:true},
      {role:"ai",text:"Totally understand, Noah! No pressure at all 😊\n\nJust so you know — we do offer Elyon Pay, our in-house payment plan. You could do your Botox now and pay $133/month over 6 months instead of upfront.\n\nAlso, Dr. Monroe has some quieter slots with a small discount this week only.\n\nWant me to hold a spot just in case?",time:"2:45 PM",read:true},
      {role:"client",text:"Oh the payment plan sounds interesting actually, tell me more",time:"3:10 PM",read:true},
      {role:"ai",text:"Great! Elyon Pay details:\n\n💳 $800 Botox treatment\n📅 6 months = $133/month\n📅 12 months = $69/month\n✅ Soft credit check only (no impact to score)\n✅ No third-party fees\n\nWant me to set up the application now? Takes 2 minutes 📱",time:"3:10 PM",read:true},
    ]
  },
  {
    id:4, client:"Claire Fontaine", phone:"(310) 555-0299", channel:"whatsapp",
    trigger:"HydraFacial", lastTreat:"2024-01-20", daysAgo:31,
    status:"sent", outcome:"waiting",
    apptBooked:null,
    messages:[
      {role:"ai",text:"Hi Claire! ✨ Your monthly HydraFacial is due! Ready to glow? Sophia Rivera has availability this week:\n\n📅 Wed Feb 21 — 2:00 PM\n📅 Thu Feb 22 — 11:00 AM\n📅 Fri Feb 23 — 3:30 PM\n\nWhich works for you? 💆‍♀️",time:"9:00 AM",read:false},
    ]
  },
  {
    id:5, client:"Maya Collins", phone:"(424) 555-0198", channel:"sms",
    trigger:"Chemical Peel", lastTreat:"2024-01-10", daysAgo:35,
    status:"cancelled", outcome:"cancelled",
    apptBooked:null,
    messages:[
      {role:"ai",text:"Hi Maya! Your chemical peel series is ready for the next session. Sophia has these slots:\n\n📅 Tue Feb 13 — 1:00 PM\n📅 Wed Feb 14 — 10:00 AM\n\nReady to book?",time:"10:00 AM",read:true},
      {role:"client",text:"Actually I want to cancel my membership for now",time:"11:30 AM",read:true},
      {role:"ai",text:"I'm sorry to hear that Maya 😢 Before I process that, may I ask — is there anything we could do to make your experience better?\n\nI can also pause your membership for up to 3 months instead of cancelling, so you don't lose your rate. Would that help?",time:"11:30 AM",read:true},
      {role:"client",text:"Actually a pause sounds better yes",time:"11:45 AM",read:true},
      {role:"ai",text:"✅ Done! I've paused your membership for 3 months (until May 2024). You won't be charged during this time.\n\nWe'll send you a reminder when it's about to resume 💛 See you when you're ready!",time:"11:45 AM",read:true},
    ]
  },
];

const AUTOMATION_FLOWS=[
  {id:1,name:"Botox Refresh Reminder",treat:"Botox",delay:90,channel:"SMS",active:true,sent:89,booked:42,rate:"47%",template:"Hi {name}! It's been 3 months since your Botox with {provider}. Ready to book your refresh? Reply YES and I'll find you a time 💉"},
  {id:2,name:"Filler Follow-up",treat:"Lip Filler",delay:180,channel:"WhatsApp",active:true,sent:34,booked:21,rate:"62%",template:"Hi {name}! Your lip filler from {date} is about 6 months old. I can check {provider}'s availability now — interested? 💋"},
  {id:3,name:"HydraFacial Monthly",treat:"HydraFacial",delay:28,channel:"SMS",active:true,sent:124,booked:68,rate:"55%",template:"Hi {name}! ✨ Your monthly HydraFacial is due. Sophia has spots this week — want me to book one?"},
  {id:4,name:"Laser Series Continue",treat:"Laser Hair Removal",delay:42,channel:"SMS",active:true,sent:56,booked:38,rate:"68%",template:"Hi {name}! Time for your next laser session 🔥 Best results with consistent timing. Book now?"},
  {id:5,name:"GLP-1 Monthly Check-in",treat:"GLP-1 Program",delay:30,channel:"WhatsApp",active:true,sent:45,booked:40,rate:"89%",template:"Hi {name}! Your monthly GLP-1 check-in is due with Dr. Monroe. Ready to book? 💊"},
  {id:6,name:"RF Microneedling Series",treat:"RF Microneedling",delay:35,channel:"SMS",active:false,sent:28,booked:15,rate:"54%",template:"Hi {name}! Your RF Microneedling series — session {session_num} is ready. Book your next session now!"},
  {id:7,name:"Win-Back (90 days)",treat:"Any",delay:90,channel:"SMS+WhatsApp",active:true,sent:67,booked:18,rate:"27%",template:"Hi {name}! We miss you at Elyon 💛 It's been a while — we'd love to welcome you back with 15% off your next visit. Book now?"},
  {id:8,name:"No-Show Recovery",treat:"Any",delay:0,channel:"SMS",active:true,sent:23,booked:12,rate:"52%",template:"Hi {name}! We missed you today 😊 Life happens! Want me to find you the next available slot? Reply YES and I'll take care of it."},
];

// ── AI AGENT BRAIN ────────────────────────────────────────────────────────────
const AI_RESPONSES={
  yes: (name,treat,slots)=>`Perfect ${name.split(" ")[0]}! Here are the next available slots for your ${treat}:\n\n${slots.map((s,i)=>`📅 ${s}`).join("\n")}\n\nWhich works best for you?`,
  slot_select: (slot,treat,prov,loc)=>`✅ Done! I've booked you:\n\n📅 ${slot}\n💉 ${treat} with ${prov}\n📍 ${loc}\n\nConfirmation sent to your phone. Reply CHANGE to reschedule or CANCEL to cancel.\n\nSee you soon! 💛`,
  cancel: (name)=>`No problem ${name.split(" ")[0]}! Your appointment has been cancelled.\n\nWhenever you're ready to rebook, just reply YES and I'll take care of it 💛`,
  reschedule: (name)=>`Of course! Here are other available times:\n\n📅 Option 1\n📅 Option 2\n📅 Option 3\n\nWhich works for you?`,
  price: (treat,price)=>`The ${treat} is $${price}. We also offer Elyon Pay — flexible payment plans starting at $69/month. Want to know more about financing? 💳`,
  budget: (name)=>`Totally understand ${name.split(" ")[0]}! No pressure 😊\n\nWe do offer Elyon Pay — our in-house payment plan:\n💳 Pay over 3, 6, or 12 months\n✅ Soft credit check only (no credit score impact)\n✅ Starting at $69/month\n\nWould that help?`,
  human: ()=>`I'm connecting you with our team now. A staff member will respond shortly. Thank you for your patience! 🙏`,
};

const AVAILABLE_SLOTS=[
  "Thu Apr 25 — 10:00 AM",
  "Thu Apr 25 — 2:30 PM",
  "Fri Apr 26 — 9:00 AM",
  "Fri Apr 26 — 11:30 AM",
  "Mon Apr 29 — 10:00 AM",
  "Mon Apr 29 — 2:00 PM",
];

// ── SHARED UI ─────────────────────────────────────────────────────────────────
const inp={width:"100%",padding:"10px 14px",background:"#f3f4f6",border:"1px solid #e8e4df",borderRadius:8,fontSize:13,color:"#1a1a2e",fontFamily:F,outline:"none",boxSizing:"border-box"};

function Btn({children,v="primary",onClick,sz="md",full,style:ex,disabled}){
  const sizes={sm:{padding:"5px 12px",fontSize:11},md:{padding:"9px 18px",fontSize:13},lg:{padding:"12px 28px",fontSize:14}};
  const vars={
    primary:{background:`linear-gradient(135deg,${C.gold},${C.goldD})`,color:"#ffffff"},
    ghost:{background:"transparent",color:C.muted,border:`1px solid ${C.border}`},
    danger:{background:C.redL,color:C.red,border:"1px solid rgba(224,85,85,0.25)"},
    success:{background:C.greenL,color:C.green,border:"1px solid rgba(46,204,135,0.25)"},
    sec:{background:C.goldBg,color:C.gold,border:`1px solid ${C.borderGold}`},
    whatsapp:{background:C.whatsappL,color:C.whatsapp,border:`1px solid rgba(37,211,102,0.25)`},
    sms:{background:C.blueL,color:C.blue,border:"1px solid rgba(74,158,255,0.25)"},
    human:{background:C.purpleL,color:C.purple,border:"1px solid rgba(155,110,243,0.25)"},
  };
  return <button onClick={onClick} disabled={disabled} style={{display:"inline-flex",alignItems:"center",gap:6,borderRadius:8,fontWeight:600,cursor:disabled?"not-allowed":"pointer",fontFamily:F,border:"none",transition:"all 0.15s",whiteSpace:"nowrap",justifyContent:"center",opacity:disabled?0.5:1,...sizes[sz],...(vars[v]||vars.ghost),...(full?{width:"100%"}:{}),...ex}}>{children}</button>;
}

function Card({children,style,onClick}){return <div onClick={onClick} style={{background:C.card,border:`1px solid ${C.border}`,borderRadius:14,overflow:"hidden",...style}}>{children}</div>;}

function StatCard({label,value,sub,color,trend}){
  return(
    <Card style={{padding:"18px 20px"}}>
      <div style={{fontSize:24,fontWeight:800,color,fontFamily:S,marginBottom:4}}>{value}</div>
      <div style={{fontSize:12,color:C.muted}}>{label}</div>
      {sub&&<div style={{fontSize:11,color:C.dim,marginTop:2}}>{sub}</div>}
      {trend!==undefined&&<div style={{fontSize:11,fontWeight:700,color:trend>0?C.green:C.red,marginTop:4}}>{trend>0?"+":""}{trend}%</div>}
    </Card>
  );
}

const ChannelBadge=({ch})=>(
  <span style={{fontSize:10,fontWeight:700,padding:"2px 8px",borderRadius:10,background:ch==="whatsapp"?C.whatsappL:C.blueL,color:ch==="whatsapp"?C.whatsapp:C.blue,display:"inline-flex",alignItems:"center",gap:4}}>
    {ch==="whatsapp"?"💬 WhatsApp":"📱 SMS"}
  </span>
);

const OutcomeBadge=({status})=>{
  const cfg={
    booked:{bg:C.greenL,c:C.green,label:"✓ Booked"},
    waiting:{bg:C.goldBg,c:C.gold,label:"⏳ Waiting"},
    objection:{bg:C.orangeL,c:C.orange,label:"💬 Objection"},
    cancelled:{bg:C.blueL,c:C.blue,label:"⏸ Paused"},
    sent:{bg:C.purpleL,c:C.purple,label:"📤 Sent"},
    pending:{bg:C.goldBg,c:C.gold,label:"🤝 Negotiating"},
  };
  const c=cfg[status]||cfg.waiting;
  return <span style={{fontSize:11,fontWeight:600,padding:"3px 10px",borderRadius:20,background:c.bg,color:c.c}}>{c.label}</span>;
};

// ── DASHBOARD ─────────────────────────────────────────────────────────────────
function AgentDashboard({conversations,setTab}){
  const booked=conversations.filter(c=>c.outcome==="booked").length;
  const totalSent=conversations.length;
  const convRate=Math.round((booked/totalSent)*100);
  const revenue=booked*750;
  const pending=conversations.filter(c=>c.outcome==="waiting"||c.outcome==="pending").length;
  const unread=conversations.filter(c=>c.messages.some(m=>!m.read&&m.role==="client")).length;

  return(
    <div style={{display:"flex",flexDirection:"column",gap:22}}>
      {/* Alert */}
      {unread>0&&(
        <div style={{padding:"14px 18px",background:"rgba(155,110,243,0.1)",border:"1px solid rgba(155,110,243,0.25)",borderRadius:10,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <div style={{display:"flex",gap:10,alignItems:"center"}}>
            <div style={{width:8,height:8,borderRadius:"50%",background:C.purple,boxShadow:`0 0 8px ${C.purple}`}}/>
            <div style={{fontSize:13,fontWeight:600,color:C.text}}>{unread} unread client message{unread>1?"s":""} — review conversations</div>
          </div>
          <Btn sz="sm" v="human" onClick={()=>setTab("conversations")}>View Now →</Btn>
        </div>
      )}

      <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:14}}>
        <StatCard label="Appointments Booked by AI" value={booked} color={C.gold} sub="This month" trend={34}/>
        <StatCard label="Conversations Started" value={totalSent} color={C.green} sub="Automated outreach"/>
        <StatCard label="Conversion Rate" value={`${convRate}%`} color={C.teal} sub="Industry avg: 22%"/>
        <StatCard label="Revenue Generated" value={`$${revenue.toLocaleString()}`} color={C.purple} sub="From AI bookings" trend={28}/>
      </div>

      {/* Live Activity */}
      <div style={{display:"grid",gridTemplateColumns:"2fr 1fr",gap:18}}>
        <Card>
          <div style={{padding:"14px 20px",borderBottom:`1px solid ${C.border}`,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
            <div style={{fontSize:14,fontWeight:700,color:C.gold,fontFamily:S}}>🤖 Recent AI Activity</div>
            <Btn sz="sm" v="ghost" onClick={()=>setTab("conversations")}>View All →</Btn>
          </div>
          {conversations.slice(0,5).map(conv=>(
            <div key={conv.id} style={{padding:"14px 20px",borderBottom:`1px solid ${C.border}`,display:"flex",gap:12,alignItems:"center"}}>
              <div style={{width:38,height:38,borderRadius:10,background:conv.channel==="whatsapp"?C.whatsappL:C.blueL,border:`1px solid ${conv.channel==="whatsapp"?"rgba(37,211,102,0.25)":"rgba(74,158,255,0.25)"}`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:14,flexShrink:0}}>
                {conv.channel==="whatsapp"?"💬":"📱"}
              </div>
              <div style={{flex:1}}>
                <div style={{fontSize:13,fontWeight:600,color:C.text,marginBottom:2}}>{conv.client}</div>
                <div style={{fontSize:11,color:C.muted}}>{conv.trigger} reminder · {conv.daysAgo} days since last visit</div>
                <div style={{fontSize:11,color:C.dim,marginTop:2}}>{conv.messages[conv.messages.length-1]?.text.slice(0,60)}...</div>
              </div>
              <OutcomeBadge status={conv.outcome}/>
            </div>
          ))}
        </Card>

        <div style={{display:"flex",flexDirection:"column",gap:14}}>
          <Card style={{padding:18}}>
            <div style={{fontSize:13,fontWeight:700,color:C.gold,fontFamily:S,marginBottom:12}}>📊 Today's AI Stats</div>
            {[["Messages Sent","24",C.gold],["Replies Received","18",C.green],["Appointments Booked","7",C.teal],["Human Takeovers","2",C.purple],["Active Chats","4",C.blue]].map(([l,v,c])=>(
              <div key={l} style={{display:"flex",justifyContent:"space-between",padding:"7px 0",borderBottom:`1px solid ${C.border}`,fontSize:12}}>
                <span style={{color:C.muted}}>{l}</span><span style={{fontWeight:700,color:c}}>{v}</span>
              </div>
            ))}
          </Card>

          <Card style={{padding:18}}>
            <div style={{fontSize:13,fontWeight:700,color:C.gold,fontFamily:S,marginBottom:12}}>🔥 Top Performing</div>
            {[["GLP-1 Follow-up","89% conv.",C.green],["Botox Reminder","47% conv.",C.gold],["Laser Series","68% conv.",C.teal]].map(([name,rate,c])=>(
              <div key={name} style={{display:"flex",justifyContent:"space-between",padding:"8px 0",borderBottom:`1px solid ${C.border}`,fontSize:12}}>
                <span style={{color:C.text}}>{name}</span><span style={{fontWeight:700,color:c}}>{rate}</span>
              </div>
            ))}
          </Card>
        </div>
      </div>

      {/* Upcoming to send */}
      <Card>
        <div style={{padding:"14px 20px",borderBottom:`1px solid ${C.border}`}}>
          <div style={{fontSize:14,fontWeight:700,color:C.gold,fontFamily:S}}>📅 Scheduled to Send Today</div>
        </div>
        {[
          {name:"Jessica Lane",treat:"Chemical Peel",channel:"SMS",time:"2:00 PM",template:"Win-Back"},
          {name:"Noah Bennett",treat:"Botox",channel:"SMS",time:"3:30 PM",template:"Follow-up"},
          {name:"Claire Fontaine",treat:"IPL Photofacial",channel:"WhatsApp",time:"4:00 PM",template:"Laser Series"},
          {name:"Dana Whitfield",treat:"GLP-1 Program",channel:"WhatsApp",time:"5:00 PM",template:"Monthly Check-in"},
        ].map((item,i)=>(
          <div key={i} style={{padding:"12px 20px",borderBottom:`1px solid ${C.border}`,display:"flex",gap:12,alignItems:"center"}}>
            <div style={{width:32,height:32,borderRadius:8,background:C.goldBg,border:`1px solid ${C.borderGold}`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:11,fontWeight:700,color:C.gold,flexShrink:0}}>{item.name.split(" ").map(n=>n[0]).join("")}</div>
            <div style={{flex:1}}>
              <div style={{fontSize:13,fontWeight:600,color:C.text}}>{item.name}</div>
              <div style={{fontSize:11,color:C.muted}}>{item.treat} · {item.template}</div>
            </div>
            <ChannelBadge ch={item.channel.toLowerCase()}/>
            <div style={{fontSize:12,fontWeight:600,color:C.gold}}>{item.time}</div>
            <Btn sz="sm" v="ghost">Skip</Btn>
          </div>
        ))}
      </Card>
    </div>
  );
}

// ── CONVERSATIONS ─────────────────────────────────────────────────────────────
function Conversations({conversations,setConversations}){
  const [sel,setSel]=useState(conversations[0]);
  const [input,setInput]=useState("");
  const [humanMode,setHumanMode]=useState(false);
  const [aiTyping,setAiTyping]=useState(false);
  const chatRef=useRef(null);

  useEffect(()=>{
    if(chatRef.current)chatRef.current.scrollTop=chatRef.current.scrollHeight;
  },[sel?.messages]);

  const sendMsg=(text,role="client")=>{
    if(!text.trim())return;
    const msg={role,text,time:new Date().toLocaleTimeString("en",{hour:"2-digit",minute:"2-digit"}),read:true};
    setConversations(cs=>cs.map(c=>c.id===sel.id?{...c,messages:[...c.messages,msg]}:c));
    setSel(prev=>({...prev,messages:[...prev.messages,msg]}));
    setInput("");

    if(role==="client"&&!humanMode){
      setAiTyping(true);
      setTimeout(()=>{
        const lower=text.toLowerCase();
        let aiText="";
        if(lower.includes("yes")||lower.includes("yeah")||lower.includes("sure")){
          aiText=AI_RESPONSES.yes(sel.client,sel.trigger,AVAILABLE_SLOTS.slice(0,4));
        }else if(lower.includes("cancel")){
          aiText=AI_RESPONSES.cancel(sel.client);
        }else if(lower.includes("budget")||lower.includes("expensive")||lower.includes("money")||lower.includes("afford")){
          aiText=AI_RESPONSES.budget(sel.client);
        }else if(lower.includes("price")||lower.includes("cost")||lower.includes("how much")){
          aiText=AI_RESPONSES.price(sel.trigger,750);
        }else if(lower.includes("reschedule")||lower.includes("change")){
          aiText=AI_RESPONSES.reschedule(sel.client);
        }else if(lower.match(/\b(mon|tue|wed|thu|fri|sat|sun|jan|feb|mar|apr|am|pm|\d+:\d+)/i)){
          aiText=AI_RESPONSES.slot_select(text,sel.trigger,"Dr. Ashley Monroe","Beverly Hills Suite A");
        }else{
          aiText="Got it! I'll pass this to our team who can help you better. Is there anything else I can assist with right now? 💛";
        }
        const aiMsg={role:"ai",text:aiText,time:new Date().toLocaleTimeString("en",{hour:"2-digit",minute:"2-digit"}),read:true};
        setConversations(cs=>cs.map(c=>c.id===sel.id?{...c,messages:[...c.messages,aiMsg]}:c));
        setSel(prev=>({...prev,messages:[...prev.messages,aiMsg]}));
        setAiTyping(false);
      },1200);
    }
  };

  const STATUS_FILTER=["all","booked","waiting","objection","pending","cancelled"];
  const [filter,setFilter]=useState("all");
  const filtered=filter==="all"?conversations:conversations.filter(c=>c.outcome===filter||c.status===filter);

  return(
    <div style={{display:"grid",gridTemplateColumns:"320px 1fr",gap:0,height:"calc(100vh - 160px)",border:`1px solid ${C.border}`,borderRadius:14,overflow:"hidden"}}>
      {/* Left — Conversation List */}
      <div style={{borderRight:`1px solid ${C.border}`,display:"flex",flexDirection:"column",background:C.surface}}>
        <div style={{padding:"12px 14px",borderBottom:`1px solid ${C.border}`}}>
          <div style={{fontSize:13,fontWeight:700,color:C.gold,fontFamily:S,marginBottom:8}}>AI Conversations</div>
          <div style={{display:"flex",gap:4,flexWrap:"wrap"}}>
            {STATUS_FILTER.slice(0,4).map(f=>(
              <button key={f} onClick={()=>setFilter(f)} style={{padding:"3px 8px",fontSize:10,fontWeight:filter===f?700:500,color:filter===f?"#09090b":C.muted,background:filter===f?C.gold:C.card,border:`1px solid ${filter===f?C.gold:C.border}`,borderRadius:10,cursor:"pointer",fontFamily:F,textTransform:"capitalize"}}>{f}</button>
            ))}
          </div>
        </div>
        <div style={{flex:1,overflow:"auto"}}>
          {filtered.map(conv=>{
            const lastMsg=conv.messages[conv.messages.length-1];
            const hasUnread=conv.messages.some(m=>!m.read&&m.role==="client");
            return(
              <div key={conv.id} onClick={()=>setSel(conv)}
                style={{padding:"14px",borderBottom:`1px solid ${C.border}`,cursor:"pointer",background:sel?.id===conv.id?C.goldBg:"transparent",transition:"all 0.15s",position:"relative"}}>
                {hasUnread&&<div style={{position:"absolute",top:14,right:14,width:8,height:8,borderRadius:"50%",background:C.purple,boxShadow:`0 0 6px ${C.purple}`}}/>}
                <div style={{display:"flex",gap:8,alignItems:"flex-start",marginBottom:6}}>
                  <div style={{flex:1}}>
                    <div style={{fontSize:13,fontWeight:700,color:C.text,marginBottom:2}}>{conv.client}</div>
                    <div style={{display:"flex",gap:6,alignItems:"center"}}>
                      <ChannelBadge ch={conv.channel}/>
                      <span style={{fontSize:10,color:C.muted}}>{conv.trigger}</span>
                    </div>
                  </div>
                  <OutcomeBadge status={conv.outcome}/>
                </div>
                <div style={{fontSize:11,color:C.dim,overflow:"hidden",whiteSpace:"nowrap",textOverflow:"ellipsis"}}>{lastMsg?.text.slice(0,50)}...</div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Right — Chat View */}
      {sel&&(
        <div style={{display:"flex",flexDirection:"column",background:C.bg}}>
          {/* Chat Header */}
          <div style={{padding:"14px 20px",borderBottom:`1px solid ${C.border}`,display:"flex",justifyContent:"space-between",alignItems:"center",background:C.surface}}>
            <div style={{display:"flex",gap:12,alignItems:"center"}}>
              <div style={{width:40,height:40,borderRadius:10,background:C.goldBg,border:`1px solid ${C.borderGold}`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:14,fontWeight:700,color:C.gold}}>{sel.client.split(" ").map(n=>n[0]).join("")}</div>
              <div>
                <div style={{fontSize:14,fontWeight:700,color:C.text}}>{sel.client}</div>
                <div style={{display:"flex",gap:8,alignItems:"center"}}>
                  <ChannelBadge ch={sel.channel}/>
                  <span style={{fontSize:11,color:C.muted}}>{sel.phone}</span>
                  <span style={{fontSize:11,color:C.dim}}>{sel.trigger} · {sel.daysAgo} days ago</span>
                </div>
              </div>
            </div>
            <div style={{display:"flex",gap:8,alignItems:"center"}}>
              {sel.apptBooked&&(
                <div style={{padding:"6px 12px",background:C.greenL,borderRadius:8,border:"1px solid rgba(46,204,135,0.25)",fontSize:11,color:C.green,fontWeight:600}}>
                  ✓ Booked: {sel.apptBooked.date} {sel.apptBooked.time}
                </div>
              )}
              <div onClick={()=>setHumanMode(!humanMode)} style={{display:"flex",alignItems:"center",gap:6,padding:"6px 12px",background:humanMode?C.purpleL:C.goldBg,borderRadius:8,border:`1px solid ${humanMode?"rgba(155,110,243,0.25)":C.borderGold}`,cursor:"pointer",fontSize:12,fontWeight:600,color:humanMode?C.purple:C.gold}}>
                {humanMode?"👤 Manual Mode":"🤖 AI Mode"}
              </div>
              <Btn sz="sm" v="ghost">View Profile</Btn>
            </div>
          </div>

          {/* Messages */}
          <div ref={chatRef} style={{flex:1,overflow:"auto",padding:"20px",display:"flex",flexDirection:"column",gap:14}}>
            {/* Trigger info */}
            <div style={{textAlign:"center",marginBottom:4}}>
              <span style={{fontSize:11,color:C.dim,background:C.surface,padding:"4px 14px",borderRadius:20,border:`1px solid ${C.border}`}}>
                🤖 AI sent {sel.trigger} reminder · {sel.daysAgo} days since last visit
              </span>
            </div>

            {sel.messages.map((msg,i)=>(
              <div key={i} style={{display:"flex",flexDirection:msg.role==="client"?"row-reverse":"row",gap:10,alignItems:"flex-end"}}>
                {msg.role==="ai"&&(
                  <div style={{width:30,height:30,borderRadius:8,background:`linear-gradient(135deg,${C.gold},${C.goldD})`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,fontSize:14}}>🤖</div>
                )}
                {msg.role==="staff"&&(
                  <div style={{width:30,height:30,borderRadius:8,background:C.purpleL,border:"1px solid rgba(155,110,243,0.3)",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,fontSize:14}}>👤</div>
                )}
                <div style={{maxWidth:"72%"}}>
                  <div style={{
                    padding:"11px 14px",
                    background:msg.role==="client"
                      ?(sel.channel==="whatsapp"?"#1a3a2a":"#1a2a3a")
                      :msg.role==="ai"?C.card:C.purpleL,
                    color:msg.role==="client"
                      ?(sel.channel==="whatsapp"?C.whatsapp:C.blue)
                      :msg.role==="ai"?C.text:C.purple,
                    borderRadius:msg.role==="client"?"14px 4px 14px 14px":"4px 14px 14px 14px",
                    fontSize:13,lineHeight:1.65,whiteSpace:"pre-line",
                    border:`1px solid ${msg.role==="client"?(sel.channel==="whatsapp"?"rgba(37,211,102,0.2)":"rgba(74,158,255,0.2)"):msg.role==="ai"?C.border:"rgba(155,110,243,0.2)"}`,
                  }}>{msg.text}</div>
                  <div style={{fontSize:10,color:C.dim,marginTop:3,textAlign:msg.role==="client"?"right":"left",paddingLeft:4}}>
                    {msg.role==="ai"?"🤖 AI Agent":msg.role==="staff"?"👤 Staff":sel.client.split(" ")[0]} · {msg.time}
                  </div>
                </div>
              </div>
            ))}

            {aiTyping&&(
              <div style={{display:"flex",gap:10,alignItems:"flex-end"}}>
                <div style={{width:30,height:30,borderRadius:8,background:`linear-gradient(135deg,${C.gold},${C.goldD})`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:14}}>🤖</div>
                <div style={{padding:"11px 16px",background:C.card,border:`1px solid ${C.border}`,borderRadius:"4px 14px 14px 14px",display:"flex",gap:4,alignItems:"center"}}>
                  {[0,1,2].map(i=><div key={i} style={{width:6,height:6,borderRadius:"50%",background:C.gold,animation:`bounce 1.2s ${i*0.2}s infinite`}}/>)}
                </div>
              </div>
            )}
          </div>

          <style>{`@keyframes bounce{0%,100%{transform:translateY(0)}50%{transform:translateY(-4px)}}`}</style>

          {/* Input */}
          <div style={{padding:"14px 20px",borderTop:`1px solid ${C.border}`,background:C.surface}}>
            {humanMode&&<div style={{fontSize:11,color:C.purple,marginBottom:8,display:"flex",alignItems:"center",gap:6}}><div style={{width:6,height:6,borderRadius:"50%",background:C.purple}}/>Manual mode — you are typing as staff</div>}
            {!humanMode&&<div style={{fontSize:11,color:C.gold,marginBottom:8,display:"flex",alignItems:"center",gap:6}}><div style={{width:6,height:6,borderRadius:"50%",background:C.gold,boxShadow:`0 0 6px ${C.gold}`}}/>AI Agent active — simulating client response</div>}

            <div style={{display:"flex",gap:8}}>
              <input value={input} onChange={e=>setInput(e.target.value)} onKeyDown={e=>e.key==="Enter"&&sendMsg(input,"client")} placeholder={humanMode?"Type as staff member...":"Simulate client reply..."} style={{...inp,flex:1}}/>
              {!humanMode&&(
                <div style={{display:"flex",gap:4}}>
                  {["Yes!","Not now","How much?","Cancel"].map(q=>(
                    <button key={q} onClick={()=>sendMsg(q,"client")} style={{padding:"6px 10px",fontSize:11,background:C.goldBg,color:C.gold,border:`1px solid ${C.borderGold}`,borderRadius:8,cursor:"pointer",fontFamily:F,whiteSpace:"nowrap"}}>{q}</button>
                  ))}
                </div>
              )}
              <Btn onClick={()=>sendMsg(input,humanMode?"staff":"client")} disabled={!input}>{humanMode?"Send":"Simulate"}</Btn>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ── AUTOMATION FLOWS ──────────────────────────────────────────────────────────
// Loads real re-engagement rules from `bot_settings.reengagement_rules`.
// Each rule has: treatment, days, message, active.
// Toggling a flow saves to DB; activating any flow auto-enables the master cron.
function AutomationFlows(){
  const [flows,setFlows]=useState([]);
  const [loading,setLoading]=useState(true);
  const [savedFlash,setSavedFlash]=useState("");
  const [sel,setSel]=useState(null);
  const [showNew,setShowNew]=useState(false);
  const [form,setForm]=useState({name:"",treat:"Botox",delay:90,channel:"SMS",template:""});
  const [editingTpl,setEditingTpl]=useState(null);
  const [tplDraft,setTplDraft]=useState("");
  const [editingDelay,setEditingDelay]=useState(null);
  const [delayDraft,setDelayDraft]=useState(0);

  // Preview modal
  const [previewFlow,setPreviewFlow]=useState(null);
  const [previewLoading,setPreviewLoading]=useState(false);
  const [previewData,setPreviewData]=useState(null);
  const [sendBusy,setSendBusy]=useState(false);
  const [sendResult,setSendResult]=useState(null);

  useEffect(()=>{ loadRules(); },[]);

  const loadRules=async()=>{
    setLoading(true);
    const {data}=await supabase.from("bot_settings").select("reengagement_rules,reengagement_enabled").eq("id",1).maybeSingle();
    const rules=Array.isArray(data?.reengagement_rules)?data.reengagement_rules:[];
    const normalized=rules.map((r,i)=>({
      id:r.id||("rule_"+i),
      name:r.name||`${r.treatment} Re-engagement`,
      treat:r.treatment,
      delay:r.days,
      channel:r.channel||"SMS",
      // Start every flow OFF unless explicitly true in the DB. The user must
      // intentionally flip a toggle before any auto-sending happens.
      active:r.active===true,
      template:r.message||"",
      sent:r.sent_count||0,
      booked:r.booked_count||0,
      rate:r.sent_count?Math.round((r.booked_count||0)/r.sent_count*100)+"%":"—",
    }));
    setFlows(normalized);
    setLoading(false);
  };

  const saveRules=async(updated)=>{
    const dbRules=updated.map(f=>({
      treatment:f.treat,
      days:f.delay,
      message:f.template,
      active:f.active,
      name:f.name,
      channel:f.channel,
    }));
    const anyActive=updated.some(f=>f.active);
    await supabase.from("bot_settings").update({
      reengagement_rules:dbRules,
      reengagement_enabled:anyActive,  // master cron auto-on when any flow is active
    }).eq("id",1);
    setSavedFlash(anyActive?"✓ Saved — daily cron is ACTIVE for active flows":"✓ Saved — all flows paused, cron will not send");
    setTimeout(()=>setSavedFlash(""),3500);
  };

  const toggle=async(id)=>{
    const updated=flows.map(f=>f.id===id?{...f,active:!f.active}:f);
    setFlows(updated);
    await saveRules(updated);
  };

  const saveTemplate=async()=>{
    if(!editingTpl)return;
    const updated=flows.map(f=>f.id===editingTpl?{...f,template:tplDraft}:f);
    setFlows(updated);
    await saveRules(updated);
    setEditingTpl(null);
  };

  const saveDelay=async()=>{
    if(!editingDelay)return;
    const days=Math.max(1,Math.min(730,parseInt(delayDraft,10)||1));
    const updated=flows.map(f=>f.id===editingDelay?{...f,delay:days}:f);
    setFlows(updated);
    await saveRules(updated);
    setEditingDelay(null);
  };

  const openPreview=async(flow)=>{
    setPreviewFlow(flow);
    setPreviewData(null);
    setSendResult(null);
    setPreviewLoading(true);
    const {data,error}=await supabase.functions.invoke("send-reengagement",{
      body:{dry_run:true,include_inactive:true,treatment_filter:flow.treat}
    });
    setPreviewLoading(false);
    if(error){setPreviewData({error:error.message});return;}
    setPreviewData(data);
  };

  const sendNow=async()=>{
    if(!previewFlow)return;
    setSendBusy(true);
    setSendResult(null);
    const {data,error}=await supabase.functions.invoke("send-reengagement",{
      body:{ignore_enabled:true,include_inactive:true,treatment_filter:previewFlow.treat}
    });
    setSendBusy(false);
    if(error){setSendResult({error:error.message});return;}
    setSendResult(data);
  };

  if(loading)return <div style={{padding:40,textAlign:"center",color:C.muted,fontSize:13}}>Loading your automations...</div>;

  const activeCount=flows.filter(f=>f.active).length;
  const bookedSum=flows.reduce((s,f)=>s+(f.booked||0),0);
  const sentSum=flows.reduce((s,f)=>s+(f.sent||0),0);
  const avgRate=sentSum?Math.round(bookedSum/sentSum*100):0;

  return(
    <div style={{display:"flex",flexDirection:"column",gap:20}}>
      {savedFlash && <div style={{padding:"10px 14px",background:C.greenL,color:C.green,borderRadius:8,fontSize:13,fontWeight:600,border:"1px solid "+C.green+"30"}}>{savedFlash}</div>}

      <div style={{padding:"14px 18px",background:activeCount>0?C.goldBg:C.light,border:"1px solid "+(activeCount>0?C.borderGold:C.border),borderRadius:12,display:"flex",justifyContent:"space-between",alignItems:"center",gap:14}}>
        <div>
          <div style={{fontSize:13,fontWeight:800,color:activeCount>0?C.gold:C.muted,fontFamily:S,marginBottom:4}}>{activeCount>0?"🟢 Daily Cron is RUNNING":"⚪ All Flows Paused"}</div>
          <div style={{fontSize:11,color:C.muted,lineHeight:1.5}}>{activeCount>0?`${activeCount} active flow${activeCount>1?"s":""} — runs daily at 1:00 PM EST. Toggle any flow off to pause it.`:"No flows are active. Turn any flow ON below to start sending re-engagements automatically each day."}</div>
        </div>
      </div>

      <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:14}}>
        {[
          ["Active Flows",activeCount,C.gold],
          ["Total Sent",sentSum,C.green],
          ["Avg Booking Rate",sentSum?avgRate+"%":"—",C.teal],
          ["Total Booked",bookedSum,C.purple],
        ].map(([l,v,c])=>(
          <Card key={l} style={{padding:"18px 20px"}}>
            <div style={{fontSize:24,fontWeight:800,color:c,fontFamily:S,marginBottom:4}}>{v}</div>
            <div style={{fontSize:12,color:C.muted}}>{l}</div>
          </Card>
        ))}
      </div>

      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
        <div style={{fontSize:14,fontWeight:700,color:C.gold,fontFamily:S}}>Treatment Follow-up Automations</div>
        <Btn onClick={()=>setShowNew(true)}>+ New Automation</Btn>
      </div>

      <div style={{display:"flex",flexDirection:"column",gap:10}}>
        {flows.map(flow=>(
          <Card key={flow.id} style={{padding:20,borderLeft:`3px solid ${flow.active?C.gold:C.border}`,cursor:"pointer",transition:"all 0.2s"}} onClick={()=>setSel(flow===sel?null:flow)}>
            <div style={{display:"flex",alignItems:"center",gap:14}}>
              <div style={{width:10,height:10,borderRadius:"50%",background:flow.active?C.green:C.dim,boxShadow:flow.active?`0 0 8px ${C.green}`:"none",flexShrink:0}}/>

              <div style={{flex:1}}>
                <div style={{display:"flex",gap:8,alignItems:"center",marginBottom:3}}>
                  <div style={{fontSize:14,fontWeight:700,color:C.text}}>{flow.name}</div>
                  <ChannelBadge ch={flow.channel==="SMS"?"sms":"whatsapp"}/>
                </div>
                <div style={{fontSize:12,color:C.muted}}>
                  <span style={{color:C.gold,fontWeight:600}}>{flow.treat}</span> · 
                  Send after <span style={{color:C.text,fontWeight:600}}> {flow.delay} days</span> · 
                  {TREAT_TIMING[flow.treat]?.label||"Custom timing"}
                </div>
              </div>

              <div style={{display:"grid",gridTemplateColumns:"repeat(3,55px)",gap:8,textAlign:"center"}}>
                {[["Sent",flow.sent,C.muted],["Booked",flow.booked,C.green],["Rate",flow.rate,C.gold]].map(([l,v,c])=>(
                  <div key={l} style={{padding:"6px",background:C.surface,borderRadius:8}}>
                    <div style={{fontSize:13,fontWeight:700,color:c}}>{v}</div>
                    <div style={{fontSize:9,color:C.dim}}>{l}</div>
                  </div>
                ))}
              </div>

              <button
                onClick={e=>{e.stopPropagation();openPreview(flow);}}
                title="See who will get this re-engagement"
                style={{padding:"7px 12px",background:C.goldBg,color:C.gold,border:"1px solid "+C.borderGold,borderRadius:8,fontSize:11,fontWeight:700,cursor:"pointer",fontFamily:F,whiteSpace:"nowrap",flexShrink:0}}
              >
                👁️ Preview
              </button>

              <div onClick={e=>{e.stopPropagation();toggle(flow.id);}} title={flow.active?"Currently ON — daily cron will send for this flow. Click to pause.":"Currently OFF. Click to activate auto-sending."} style={{width:42,height:22,borderRadius:11,background:flow.active?C.green:C.light,position:"relative",cursor:"pointer",transition:"background 0.2s",flexShrink:0,border:"1px solid "+(flow.active?C.green:C.border)}}>
                <div style={{position:"absolute",top:2,left:flow.active?22:2,width:18,height:18,borderRadius:"50%",background:"#fff",transition:"left 0.2s",boxShadow:"0 1px 3px rgba(0,0,0,0.2)"}}/>
              </div>
            </div>

            {sel?.id===flow.id&&(
              <div style={{marginTop:16,paddingTop:16,borderTop:`1px solid ${C.border}`}}>
                <div style={{fontSize:11,fontWeight:700,color:C.gold,textTransform:"uppercase",letterSpacing:"0.1em",marginBottom:8}}>Send After</div>
                {editingDelay===flow.id?(
                  <div style={{display:"flex",gap:8,alignItems:"center",marginBottom:14}}>
                    <input type="number" min="1" max="730" value={delayDraft} onChange={e=>setDelayDraft(e.target.value)} style={{...inp,maxWidth:140}}/>
                    <span style={{fontSize:13,color:C.muted}}>days after treatment</span>
                    <Btn sz="sm" onClick={(e)=>{e.stopPropagation();saveDelay();}}>💾 Save</Btn>
                    <Btn sz="sm" v="ghost" onClick={(e)=>{e.stopPropagation();setEditingDelay(null);}}>Cancel</Btn>
                  </div>
                ):(
                  <div style={{display:"flex",gap:10,alignItems:"center",marginBottom:14}}>
                    <div style={{padding:"6px 12px",background:C.surface,border:"1px solid "+C.border,borderRadius:8,fontSize:13,color:C.text,fontWeight:600}}>{flow.delay} days after the appointment</div>
                    <Btn sz="sm" v="sec" onClick={(e)=>{e.stopPropagation();setEditingDelay(flow.id);setDelayDraft(flow.delay);}}>✏️ Change</Btn>
                    <span style={{fontSize:10,color:C.muted,fontStyle:"italic"}}>Scan window: ±3 days around this</span>
                  </div>
                )}
                <div style={{fontSize:11,fontWeight:700,color:C.gold,textTransform:"uppercase",letterSpacing:"0.1em",marginBottom:8}}>Message Template</div>
                {editingTpl===flow.id?(
                  <div>
                    <textarea value={tplDraft} onChange={e=>setTplDraft(e.target.value)} rows={4} style={{...inp,resize:"vertical",marginBottom:8}} placeholder="Hi {{name}}! It's been {{human_time}} since your {{treatment}}..."/>
                    <div style={{display:"flex",gap:8,marginBottom:12}}>
                      <Btn sz="sm" onClick={(e)=>{e.stopPropagation();saveTemplate();}}>💾 Save</Btn>
                      <Btn sz="sm" v="ghost" onClick={(e)=>{e.stopPropagation();setEditingTpl(null);}}>Cancel</Btn>
                    </div>
                  </div>
                ):(
                  <div style={{padding:"12px 14px",background:C.surface,borderRadius:8,border:`1px solid ${C.border}`,fontSize:12,color:C.text,lineHeight:1.7,marginBottom:12,whiteSpace:"pre-wrap"}}>{flow.template||<span style={{color:C.muted,fontStyle:"italic"}}>(no custom template — using AI default with personalized name + days)</span>}</div>
                )}
                <div style={{fontSize:11,color:C.muted,marginBottom:12}}>Variables: <span style={{color:C.gold}}>{"{{name}}"}</span> <span style={{color:C.gold}}>{"{{human_time}}"}</span> <span style={{color:C.gold}}>{"{{days}}"}</span> <span style={{color:C.gold}}>{"{{treatment}}"}</span></div>
                <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
                  <Btn sz="sm" v="sec" onClick={(e)=>{e.stopPropagation();setEditingTpl(flow.id);setTplDraft(flow.template||"");}}>✏️ Edit Template</Btn>
                  <Btn sz="sm" v="primary" onClick={(e)=>{e.stopPropagation();openPreview(flow);}}>👁️ Preview — see who gets it</Btn>
                  <Btn sz="sm" v={flow.active?"danger":"success"} onClick={(e)=>{e.stopPropagation();toggle(flow.id);}}>{flow.active?"⏸ Pause Auto":"▶️ Activate Auto"}</Btn>
                </div>
              </div>
            )}
          </Card>
        ))}
      </div>

      {previewFlow&&(
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.85)",zIndex:1000,display:"flex",alignItems:"center",justifyContent:"center",padding:20,backdropFilter:"blur(8px)"}} onClick={(e)=>{if(e.target===e.currentTarget){setPreviewFlow(null);}}}>
          <div style={{background:C.card,border:`1px solid ${C.borderGold}`,borderRadius:16,width:"100%",maxWidth:640,maxHeight:"90vh",overflow:"auto",boxShadow:"0 32px 80px rgba(0,0,0,0.6)"}}>
            <div style={{display:"flex",justifyContent:"space-between",padding:"20px 24px",borderBottom:`1px solid ${C.border}`}}>
              <div>
                <div style={{fontSize:16,fontWeight:700,color:C.gold,fontFamily:S}}>👁️ Preview: {previewFlow.name}</div>
                <div style={{fontSize:11,color:C.muted,marginTop:3}}>{previewFlow.treat} · after {previewFlow.delay} days</div>
              </div>
              <button onClick={()=>setPreviewFlow(null)} style={{background:C.light,border:"none",borderRadius:8,padding:6,cursor:"pointer",color:C.muted,width:30,height:30}}>✕</button>
            </div>

            <div style={{padding:24}}>
              {previewLoading && <div style={{padding:30,textAlign:"center",color:C.muted,fontSize:13}}>Scanning clients who need this re-engagement...</div>}

              {previewData?.error && <div style={{padding:12,background:C.redL,color:C.red,borderRadius:8,fontSize:12,fontWeight:600,marginBottom:14}}>Error: {previewData.error}</div>}

              {previewData && !previewData.error && (
                <>
                  <div style={{padding:"14px 16px",background:previewData.queued>0?C.goldBg:C.light,borderRadius:10,border:"1px solid "+(previewData.queued>0?C.borderGold:C.border),marginBottom:14}}>
                    <div style={{fontSize:26,fontWeight:800,color:previewData.queued>0?C.gold:C.muted,fontFamily:S,lineHeight:1}}>
                      {previewData.queued} client{previewData.queued===1?"":"s"}
                    </div>
                    <div style={{fontSize:11,color:C.muted,marginTop:6}}>will get a {previewFlow.treat} re-engagement SMS if you click "Send Now"</div>
                  </div>

                  {(previewData.preview||[]).length===0?(
                    <div style={{padding:30,textAlign:"center",color:C.muted,fontSize:12,background:C.light,borderRadius:10,border:"1px dashed "+C.border,marginBottom:14}}>
                      🎉 No clients are due for {previewFlow.treat} re-engagement right now.<br/>The cron will check again tomorrow.
                    </div>
                  ):(
                    <div style={{maxHeight:300,overflowY:"auto",border:"1px solid "+C.border,borderRadius:10,marginBottom:14}}>
                      {(previewData.preview||[]).map((p,i)=>(
                        <div key={i} style={{padding:"11px 14px",borderBottom:i<previewData.preview.length-1?"1px solid "+C.border:"none",display:"flex",alignItems:"center",gap:10}}>
                          <div style={{width:34,height:34,borderRadius:"50%",background:C.goldBg,border:"1px solid "+C.borderGold,display:"flex",alignItems:"center",justifyContent:"center",fontSize:12,fontWeight:700,color:C.gold,flexShrink:0}}>
                            {(p.client_name||"?").split(" ").map(n=>n[0]).join("").substring(0,2).toUpperCase()}
                          </div>
                          <div style={{flex:1,minWidth:0}}>
                            <div style={{fontSize:13,fontWeight:700,color:C.text}}>{p.client_name}</div>
                            <div style={{fontSize:11,color:C.muted}}>{p.phone} · last visit {new Date(p.last_treatment_date).toLocaleDateString("en-US",{month:"short",day:"numeric",year:"numeric"})}</div>
                          </div>
                          <div style={{fontSize:11,color:C.gold,fontWeight:700,whiteSpace:"nowrap"}}>{p.days_since}d ago</div>
                        </div>
                      ))}
                    </div>
                  )}

                  {sendResult?.error && <div style={{padding:12,background:C.redL,color:C.red,borderRadius:8,fontSize:12,fontWeight:600,marginBottom:14}}>Send error: {sendResult.error}</div>}
                  {sendResult && !sendResult.error && (
                    <div style={{padding:12,background:C.greenL,color:C.green,borderRadius:8,fontSize:13,fontWeight:700,marginBottom:14}}>
                      ✅ Sent {sendResult.sent} of {sendResult.queued} messages.{sendResult.failed>0?` (${sendResult.failed} skipped/failed — check logs)`:""}
                    </div>
                  )}

                  <div style={{padding:"10px 12px",background:C.surface,borderRadius:8,fontSize:11,color:C.muted,marginBottom:14,border:"1px solid "+C.border,lineHeight:1.5}}>
                    💡 Each SMS is fully personalized — uses the client's first name and the exact days since their last treatment. No two clients get the same generic blast.
                  </div>

                  <div style={{display:"flex",gap:10,justifyContent:"flex-end"}}>
                    <Btn v="ghost" onClick={()=>setPreviewFlow(null)}>Close</Btn>
                    <Btn
                      onClick={sendNow}
                      disabled={sendBusy||previewData.queued===0||sendResult}
                    >
                      {sendBusy?"Sending...":sendResult?"✓ Sent":`📤 Send Now to ${previewData.queued}`}
                    </Btn>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      )}

      {showNew&&(
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.85)",zIndex:1000,display:"flex",alignItems:"center",justifyContent:"center",padding:20,backdropFilter:"blur(8px)"}}>
          <div style={{background:C.card,border:`1px solid ${C.borderGold}`,borderRadius:16,width:"100%",maxWidth:580,maxHeight:"90vh",overflow:"auto",boxShadow:"0 32px 80px rgba(0,0,0,0.6)"}}>
            <div style={{display:"flex",justifyContent:"space-between",padding:"20px 24px",borderBottom:`1px solid ${C.border}`}}>
              <div style={{fontSize:16,fontWeight:700,color:C.gold,fontFamily:S}}>New Automation Flow</div>
              <button onClick={()=>setShowNew(false)} style={{background:C.light,border:"none",borderRadius:8,padding:6,cursor:"pointer",color:C.muted}}>✕</button>
            </div>
            <div style={{padding:24,display:"flex",flexDirection:"column",gap:14}}>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
                <div><label style={{display:"block",fontSize:11,fontWeight:700,color:C.gold,textTransform:"uppercase",letterSpacing:"0.1em",marginBottom:7}}>Flow Name</label><input value={form.name} onChange={e=>setForm({...form,name:e.target.value})} style={inp}/></div>
                <div><label style={{display:"block",fontSize:11,fontWeight:700,color:C.gold,textTransform:"uppercase",letterSpacing:"0.1em",marginBottom:7}}>Treatment</label>
                  <select value={form.treat} onChange={e=>{const t=e.target.value;setForm({...form,treat:t,delay:TREAT_TIMING[t]?.days||30});}} style={{...inp}}>
                    {Object.keys(TREAT_TIMING).map(t=><option key={t}>{t}</option>)}
                    <option>Any</option>
                  </select>
                </div>
                <div><label style={{display:"block",fontSize:11,fontWeight:700,color:C.gold,textTransform:"uppercase",letterSpacing:"0.1em",marginBottom:7}}>Send After (days)</label><input type="number" value={form.delay} onChange={e=>setForm({...form,delay:+e.target.value})} style={inp}/></div>
                <div><label style={{display:"block",fontSize:11,fontWeight:700,color:C.gold,textTransform:"uppercase",letterSpacing:"0.1em",marginBottom:7}}>Channel</label>
                  <select value={form.channel} onChange={e=>setForm({...form,channel:e.target.value})} style={{...inp}}>
                    <option>SMS</option><option>WhatsApp</option><option>SMS+WhatsApp</option><option>Email</option>
                  </select>
                </div>
              </div>
              {form.treat&&TREAT_TIMING[form.treat]&&(
                <div style={{padding:"10px 14px",background:C.goldBg,borderRadius:8,border:`1px solid ${C.borderGold}`,fontSize:12,color:C.gold}}>
                  💡 Recommended for {form.treat}: send after <strong>{TREAT_TIMING[form.treat].days} days</strong> ({TREAT_TIMING[form.treat].label})
                </div>
              )}
              <div><label style={{display:"block",fontSize:11,fontWeight:700,color:C.gold,textTransform:"uppercase",letterSpacing:"0.1em",marginBottom:7}}>Message Template</label>
                <textarea value={form.template} onChange={e=>setForm({...form,template:e.target.value})} rows={4} style={{...inp,resize:"none"}} placeholder={`Hi {name}! It's been ${form.delay} days since your ${form.treat}. Ready to book your refresh? 💉`}/>
                <div style={{fontSize:10,color:C.muted,marginTop:4}}>Variables: {"{name}"} {"{provider}"} {"{date}"} {"{treat}"} {"{spa_name}"}</div>
              </div>
              <div style={{display:"flex",gap:10,justifyContent:"flex-end",marginTop:6}}>
                <Btn v="ghost" onClick={()=>setShowNew(false)}>Cancel</Btn>
                <Btn onClick={async()=>{
                  if(!form.name||!form.treat)return;
                  const newFlow={id:"rule_"+Date.now(),sent:0,booked:0,rate:"—",active:false,...form};
                  const updated=[...flows,newFlow];
                  setFlows(updated);
                  await saveRules(updated);
                  setShowNew(false);
                  setForm({name:"",treat:"Botox",delay:90,channel:"SMS",template:""});
                }}>Create Flow (starts paused)</Btn>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ── AI AGENT SETTINGS ─────────────────────────────────────────────────────────
function AgentSettings(){
  const [settings,setSettings]=useState({
    name:"Elyon AI",persona:"Friendly, professional, luxury spa vibe. Always warm, never pushy.",
    greetingSMS:"Hi {name}! It's {spa_name} — ",
    greetingWA:"Hi {name}! 👋 It's your Elyon assistant — ",
    autoBook:true,autoConfirm:true,humanHandoff:true,handoffKeywords:"human,staff,person,angry,complaint",
    sendTime:"optimal",sendTimeFrom:"9:00",sendTimeTo:"19:00",
    followUpIfNoReply:true,followUpDays:3,maxFollowUps:2,
    languages:["English","Spanish"],
    objectionResponse:true,elyonPayOffer:true,
  });

  return(
    <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:18}}>
      <div style={{display:"flex",flexDirection:"column",gap:14}}>
        <Card style={{padding:22}}>
          <div style={{fontSize:14,fontWeight:700,color:C.gold,fontFamily:S,marginBottom:18}}>🤖 AI Agent Identity</div>
          <div style={{display:"flex",flexDirection:"column",gap:12}}>
            <div><label style={{display:"block",fontSize:11,fontWeight:700,color:C.gold,textTransform:"uppercase",letterSpacing:"0.1em",marginBottom:7}}>Agent Name</label><input value={settings.name} onChange={e=>setSettings({...settings,name:e.target.value})} style={inp}/></div>
            <div><label style={{display:"block",fontSize:11,fontWeight:700,color:C.gold,textTransform:"uppercase",letterSpacing:"0.1em",marginBottom:7}}>Persona / Tone</label><textarea value={settings.persona} onChange={e=>setSettings({...settings,persona:e.target.value})} rows={3} style={{...inp,resize:"none"}}/></div>
            <div><label style={{display:"block",fontSize:11,fontWeight:700,color:C.gold,textTransform:"uppercase",letterSpacing:"0.1em",marginBottom:7}}>SMS Greeting</label><input value={settings.greetingSMS} onChange={e=>setSettings({...settings,greetingSMS:e.target.value})} style={inp}/></div>
            <div><label style={{display:"block",fontSize:11,fontWeight:700,color:C.gold,textTransform:"uppercase",letterSpacing:"0.1em",marginBottom:7}}>WhatsApp Greeting</label><input value={settings.greetingWA} onChange={e=>setSettings({...settings,greetingWA:e.target.value})} style={inp}/></div>
          </div>
        </Card>

        <Card style={{padding:22}}>
          <div style={{fontSize:14,fontWeight:700,color:C.gold,fontFamily:S,marginBottom:16}}>⏰ Send Timing</div>
          {[["Send at optimal time (AI decides)","sendTime_optimal"],["Avoid send after hours","sendTime_noevenings"]].map(([label,key])=>(
            <div key={key} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"10px 0",borderBottom:`1px solid ${C.border}`}}>
              <span style={{fontSize:13,color:C.text}}>{label}</span>
              <div style={{width:42,height:22,borderRadius:11,background:C.green,position:"relative",cursor:"pointer"}}>
                <div style={{position:"absolute",top:2,left:22,width:18,height:18,borderRadius:"50%",background:"#fff"}}/>
              </div>
            </div>
          ))}
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginTop:14}}>
            <div><label style={{display:"block",fontSize:11,fontWeight:700,color:C.gold,textTransform:"uppercase",letterSpacing:"0.1em",marginBottom:7}}>From</label><input type="time" value={settings.sendTimeFrom} onChange={e=>setSettings({...settings,sendTimeFrom:e.target.value})} style={inp}/></div>
            <div><label style={{display:"block",fontSize:11,fontWeight:700,color:C.gold,textTransform:"uppercase",letterSpacing:"0.1em",marginBottom:7}}>To</label><input type="time" value={settings.sendTimeTo} onChange={e=>setSettings({...settings,sendTimeTo:e.target.value})} style={inp}/></div>
          </div>
        </Card>
      </div>

      <div style={{display:"flex",flexDirection:"column",gap:14}}>
        <Card style={{padding:22}}>
          <div style={{fontSize:14,fontWeight:700,color:C.gold,fontFamily:S,marginBottom:16}}>⚙️ Agent Capabilities</div>
          {[["autoBook","Auto-book appointments","AI books directly into CRM"],["autoConfirm","Send confirmation automatically","After booking, AI sends confirmation"],["humanHandoff","Human handoff when needed","Detect frustration and escalate"],["objectionResponse","Handle objections","Budget, timing, uncertainty responses"],["elyonPayOffer","Offer Elyon Pay if budget concern","Automatically suggest payment plans"],["followUpIfNoReply","Follow up if no reply","Re-send if client doesn't respond"]].map(([key,label,sub])=>(
            <div key={key} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"10px 0",borderBottom:`1px solid ${C.border}`}}>
              <div><div style={{fontSize:13,color:C.text,fontWeight:500}}>{label}</div><div style={{fontSize:11,color:C.muted}}>{sub}</div></div>
              <div onClick={()=>setSettings(s=>({...s,[key]:!s[key]}))} style={{width:42,height:22,borderRadius:11,background:settings[key]?C.green:C.light,position:"relative",cursor:"pointer",transition:"background 0.2s",flexShrink:0}}>
                <div style={{position:"absolute",top:2,left:settings[key]?22:2,width:18,height:18,borderRadius:"50%",background:"#fff",transition:"left 0.2s"}}/>
              </div>
            </div>
          ))}
        </Card>

        <Card style={{padding:22}}>
          <div style={{fontSize:14,fontWeight:700,color:C.gold,fontFamily:S,marginBottom:16}}>🚨 Human Handoff Triggers</div>
          <div style={{fontSize:12,color:C.muted,marginBottom:12}}>AI will automatically hand off to staff if client says:</div>
          <div style={{display:"flex",flexWrap:"wrap",gap:8,marginBottom:14}}>
            {settings.handoffKeywords.split(",").map(kw=>(
              <span key={kw} style={{fontSize:12,padding:"4px 12px",background:C.redL,color:C.red,borderRadius:20,border:"1px solid rgba(224,85,85,0.25)",fontWeight:600}}>{kw.trim()}</span>
            ))}
          </div>
          <input value={settings.handoffKeywords} onChange={e=>setSettings({...settings,handoffKeywords:e.target.value})} placeholder="Add keywords separated by commas..." style={inp}/>
          <div style={{marginTop:14,padding:"12px",background:"rgba(155,110,243,0.08)",borderRadius:8,border:"1px solid rgba(155,110,243,0.2)",fontSize:12,color:C.purple}}>
            👤 Staff gets instant notification when AI hands off. Response time goal: &lt;5 minutes.
          </div>
        </Card>

        <Card style={{padding:22}}>
          <div style={{fontSize:14,fontWeight:700,color:C.gold,fontFamily:S,marginBottom:14}}>🌍 Languages</div>
          {["English","Spanish","Hebrew","French","Portuguese"].map(lang=>(
            <label key={lang} style={{display:"flex",alignItems:"center",gap:8,cursor:"pointer",padding:"8px 0",borderBottom:`1px solid ${C.border}`,fontSize:13,color:C.text}}>
              <input type="checkbox" checked={settings.languages.includes(lang)} onChange={e=>setSettings(s=>({...s,languages:e.target.checked?[...s.languages,lang]:s.languages.filter(l=>l!==lang)}))} style={{accentColor:C.gold}}/>
              {lang} {lang==="English"&&"🇺🇸"}{lang==="Spanish"&&"🇪🇸"}{lang==="Hebrew"&&"🇮🇱"}
            </label>
          ))}
        </Card>

        <Btn full v="primary" sz="lg">💾 Save Agent Settings</Btn>
      </div>
    </div>
  );
}

// ── ANALYTICS ─────────────────────────────────────────────────────────────────
function AgentAnalytics({conversations}){
  const booked=conversations.filter(c=>c.outcome==="booked").length;
  const total=conversations.length;

  return(
    <div style={{display:"flex",flexDirection:"column",gap:20}}>
      <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:14}}>
        {[
          ["AI Booking Rate",`${Math.round(booked/total*100)}%`,C.gold,"vs 22% industry avg"],
          ["Avg Response Time","4.2 min",C.green,"Client first reply"],
          ["Revenue Attributed","$31,500",C.purple,"From AI conversations"],
          ["Hours Saved","127 hrs",C.teal,"Staff time this month"],
        ].map(([l,v,c,sub])=>(
          <Card key={l} style={{padding:"18px 20px"}}>
            <div style={{fontSize:24,fontWeight:800,color:c,fontFamily:S,marginBottom:4}}>{v}</div>
            <div style={{fontSize:12,color:C.muted}}>{l}</div>
            <div style={{fontSize:11,color:C.dim,marginTop:2}}>{sub}</div>
          </Card>
        ))}
      </div>

      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:18}}>
        <Card style={{padding:22}}>
          <div style={{fontSize:14,fontWeight:700,color:C.gold,fontFamily:S,marginBottom:16}}>Conversation Outcomes</div>
          {[["Appointment Booked",booked,"#2ecc87"],["Waiting for Reply",conversations.filter(c=>c.outcome==="waiting").length,"#c9a84c"],["Objection Handling",conversations.filter(c=>c.outcome==="objection"||c.outcome==="pending").length,"#f97316"],["Cancelled/Paused",conversations.filter(c=>c.outcome==="cancelled").length,"#4a9eff"]].map(([l,v,c])=>(
            <div key={l} style={{marginBottom:14}}>
              <div style={{display:"flex",justifyContent:"space-between",fontSize:12,marginBottom:5}}>
                <span style={{color:C.text}}>{l}</span>
                <span style={{fontWeight:700,color:c}}>{v} ({Math.round(v/total*100)}%)</span>
              </div>
              <div style={{height:5,background:C.light,borderRadius:3}}>
                <div style={{height:"100%",width:`${Math.round(v/total*100)}%`,background:c,borderRadius:3}}/>
              </div>
            </div>
          ))}
        </Card>

        <Card style={{padding:22}}>
          <div style={{fontSize:14,fontWeight:700,color:C.gold,fontFamily:S,marginBottom:16}}>Best Performing Automations</div>
          {AUTOMATION_FLOWS.filter(f=>f.booked>0).sort((a,b)=>b.booked/b.sent-a.booked/a.sent).slice(0,5).map(f=>(
            <div key={f.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"10px 0",borderBottom:`1px solid ${C.border}`}}>
              <div>
                <div style={{fontSize:12,fontWeight:600,color:C.text}}>{f.name}</div>
                <div style={{fontSize:11,color:C.muted}}>{f.treat} · {f.sent} sent</div>
              </div>
              <div style={{textAlign:"right"}}>
                <div style={{fontSize:14,fontWeight:800,color:C.gold,fontFamily:S}}>{f.rate}</div>
                <div style={{fontSize:10,color:C.muted}}>{f.booked} booked</div>
              </div>
            </div>
          ))}
        </Card>
      </div>
    </div>
  );
}

// ── APP ───────────────────────────────────────────────────────────────────────
const LOGO_SVG=()=>(
  <svg width={32} height={32} viewBox="0 0 40 40" fill="none">
    <defs><linearGradient id="eg" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stopColor="#e8c96a"/><stop offset="100%" stopColor="#8a6f2e"/></linearGradient></defs>
    <circle cx="20" cy="20" r="19" fill="none" stroke="#c9a84c" strokeWidth="1"/>
    <path d="M20 4L22.5 14.5L33 18L22.5 21.5L20 32L17.5 21.5L7 18L17.5 14.5Z" fill="url(#eg)"/>
    <circle cx="20" cy="20" r="3" fill="#09090b" stroke="#c9a84c" strokeWidth="1"/>
    <circle cx="20" cy="20" r="1.5" fill="url(#eg)"/>
  </svg>
);

const TABS=[
  {id:"dashboard",label:"Dashboard",emoji:"📊"},
  {id:"conversations",label:"Live Conversations",emoji:"💬"},
  {id:"flows",label:"Automation Flows",emoji:"⚡"},
  {id:"analytics",label:"Analytics",emoji:"📈"},
  {id:"settings",label:"Agent Settings",emoji:"⚙️"},
];

export default function App(){
  const [tab,setTab]=useState("dashboard");
  const [conversations,setConversations]=useState(INIT_CONVERSATIONS);
  const unread=conversations.filter(c=>c.messages.some(m=>!m.read&&m.role==="client")).length;

  return(
    <div style={{minHeight:"100vh",background:C.bg,fontFamily:F,color:C.text}}>
      <link href="https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700;800&family=Cormorant+Garamond:wght@400;600;700;800&display=swap" rel="stylesheet"/>

      <div style={{background:C.surface,borderBottom:`1px solid ${C.border}`,padding:"0 32px",height:58,display:"flex",alignItems:"center",gap:16,position:"sticky",top:0,zIndex:50}}>
        <div style={{display:"flex",alignItems:"center",gap:10,marginRight:12,flexShrink:0}}>
          <LOGO_SVG/>
          <div style={{fontSize:16,fontWeight:800,color:"#c9a84c",fontFamily:S,letterSpacing:"0.1em"}}>ELYON</div>
          <div style={{fontSize:10,color:C.dim,background:C.goldBg,padding:"2px 8px",borderRadius:10,border:`1px solid rgba(201,168,76,0.2)`,letterSpacing:"0.08em",flexShrink:0}}>AI AGENT</div>
        </div>
        <div style={{display:"flex",gap:4}}>
          {TABS.map(t=>(
            <button key={t.id} onClick={()=>setTab(t.id)} style={{padding:"6px 12px",fontSize:11,fontWeight:tab===t.id?700:500,color:tab===t.id?"#09090b":C.muted,background:tab===t.id?"#c9a84c":"transparent",border:`1px solid ${tab===t.id?"#c9a84c":C.border}`,borderRadius:8,cursor:"pointer",fontFamily:F,transition:"all 0.15s",display:"flex",alignItems:"center",gap:5,position:"relative"}}>
              <span>{t.emoji}</span><span>{t.label}</span>
              {t.id==="conversations"&&unread>0&&<span style={{position:"absolute",top:-4,right:-4,width:16,height:16,borderRadius:"50%",background:C.purple,color:"#fff",fontSize:9,fontWeight:800,display:"flex",alignItems:"center",justifyContent:"center"}}>{unread}</span>}
            </button>
          ))}
        </div>
        <div style={{marginLeft:"auto",display:"flex",gap:8,alignItems:"center"}}>
          <div style={{display:"flex",alignItems:"center",gap:6,padding:"5px 12px",background:"rgba(46,204,135,0.1)",borderRadius:8,border:"1px solid rgba(46,204,135,0.2)"}}>
            <div style={{width:7,height:7,borderRadius:"50%",background:C.green,boxShadow:`0 0 8px ${C.green}`}}/>
            <div style={{fontSize:11,color:C.green,fontWeight:700}}>AI AGENT ONLINE</div>
          </div>
          <div style={{fontSize:11,color:C.gold,padding:"5px 12px",background:C.goldBg,borderRadius:8,border:`1px solid ${C.borderGold}`,fontWeight:600}}>
            {conversations.filter(c=>c.outcome==="booked").length} booked today
          </div>
        </div>
      </div>

      <div style={{padding:"28px 32px"}}>
        <div style={{marginBottom:24}}>
          <div style={{fontSize:26,fontWeight:800,color:C.text,fontFamily:S}}>{TABS.find(t=>t.id===tab)?.emoji} {TABS.find(t=>t.id===tab)?.label}</div>
          <div style={{fontSize:12,color:C.muted,marginTop:4}}>Elyon AI Booking Agent · SMS + WhatsApp · Beverly Hills</div>
        </div>

        {tab==="dashboard"&&<AgentDashboard conversations={conversations} setTab={setTab}/>}
        {tab==="conversations"&&<Conversations conversations={conversations} setConversations={setConversations}/>}
        {tab==="flows"&&<AutomationFlows/>}
        {tab==="analytics"&&<AgentAnalytics conversations={conversations}/>}
        {tab==="settings"&&<AgentSettings/>}
      </div>
    </div>
  );
}
